(function() {
    if (typeof window.CustomEvent === "function") return false;

    function CustomEvent(event, params) {
        params = params || {
            bubbles: false,
            cancelable: false,
            detail: undefined
        };
        var evt = document.createEvent("CustomEvent");
        evt.initCustomEvent(
            event,
            params.bubbles,
            params.cancelable,
            params.detail
        );
        return evt;
    }

    CustomEvent.prototype = window.Event.prototype;

    window.CustomEvent = CustomEvent;
})();

import store from "./state/store/";

class InteractivePanel {
    constructor(options) {
        this.dom = {
            el: options.panel
        };

        this.collection_bar = options.collection_bar;

        if (options.panel !== undefined && options.panel !== null) {
            this.bus = document.createElement("div");
            this.assign();
            this.events();
        }
    }

    assign() {
        this.dom.tabs = [...this.dom.el.querySelectorAll(".tab")];
        this.dom.letters = [...this.dom.el.querySelectorAll(".letter-tag")];

        // Assign lettes to tabs for later
        this.dom.tabs.map(tab => {
            let pid = tab.getAttribute("data-product-id");

            let ls = this.dom.letters.filter(letr => {
                if (letr.getAttribute("data-product-id") == pid) {
                    return letr;
                }
            });

            if (ls.length > 0) {
                tab.data = {
                    sku: ls[0].getAttribute("data-product-sku"),
                    id: pid,
                    alt: ls[0]
                };

                ls[0].data = {
                    sku: ls[0].getAttribute("data-product-sku"),
                    id: pid,
                    alt: tab
                };
            }

            let details = tab.querySelector(".details");

            if (details) {
                details.addEventListener("click", () => {
                    let modal_id = tab.data.id;
                    if (modal_id.indexOf("-")) {
                        modal_id = modal_id.split("-")[1];
                    }

                    window.showModal("product", modal_id);
                });
            }
        });
    }

    manage_hover(els) {
        els.map(el => {
            let pid = el.getAttribute("data-product-id");

            el.addEventListener(
                "mouseenter",
                e => {
                    if (!el.classList.contains("hover")) {
                        el.classList.add("hover");
                    }

                    el.data.alt.classList.add("hover");
                },
                false
            );

            el.addEventListener(
                "mouseleave",
                e => {
                    if (e.target === e.currentTarget) {
                        el.classList.remove("hover");

                        el.data.alt.classList.remove("hover");
                    }
                },
                false
            );
        });
    }

    manage_select(els) {
        els.map(el => {
            let pid = el.getAttribute("data-product-id");

            el.addEventListener(
                "click",
                e => {
                    // NEEEEEED A BETTER WAY TO DO THIS
                    if (e.target.innerHTML.indexOf("details") !== 0) {
                        if (!el.classList.contains("active")) {
                            this.add(el);
                        } else {
                            this.remove(el);
                        }
                    }
                },
                false
            );
        });
    }

    selected() {
        let selected = this.dom.tabs.filter(t => {
            return t.classList.contains("active");
        });

        if (selected.length > 0) {
            return selected[0];
        }
    }

    events() {
        // Refactor to allow for list of lists DRY
        this.manage_hover(this.dom.letters);
        this.manage_hover(this.dom.tabs);

        this.manage_select(this.dom.letters);
        this.manage_select(this.dom.tabs);

        this.bus.addEventListener("remove", () => {
            this.collection_bar.close();
        });
    }

    add(el) {
        let data = el.data;
        let event = new CustomEvent("add");

        let json = JSON.stringify({
            sku: data.sku,
            quantity: 1,
            id: data.id
        });

        store.dispatch("staged_add", json);

        el.classList.add("active");
        el.data.alt.classList.add("active");

        this.collection_bar.open();

        window.stagedProducts.add(json);
        this.bus.dispatchEvent(event);
    }

    remove(el) {
        let data = el.data;
        let event = new CustomEvent("remove");

        let json = JSON.stringify({
            sku: data.sku,
            quantity: 1,
            id: data.id
        });

        el.classList.remove("active");
        el.data.alt.classList.remove("active");

        window.stagedProducts.delete(json);
        this.bus.dispatchEvent(event);
    }
}

export default InteractivePanel;
